export default __webpack_public_path__ + "be42b8befc23276e905e9dd3f999ce40.svg";